import Modals from "../../components/common/Modal";
import React, { useState, useEffect } from "react";
import axiosMain from "../../http/axios/axios_main";
//import CustomToast from "../../components/Toast";

function BankReportsUserRoleWise({ open, setOpen, linkId }) {
 
  const userRole = atob(sessionStorage.getItem("argument6"));
  const userCode = atob(sessionStorage.getItem("argument4"));
  const [redeemClicked, setRedeemClicked] = useState(true);

  useEffect(() => {
if(open=="BankReportsUserRoleWise" && (userRole == "BUYER" || userRole == "TEABOARDUSER" || userRole == "AUCTIONEER" || userRole == "WAREHOUSE") ){
    const fetchData = async () => {
      try {
        const url = `/postauction/allocateFund/BankReportsUserRoleWise/${userCode}/${linkId}`;
        const response = await axiosMain.post(url);
        //setRedeemClicked(true);
        if (response.status === 200) {
          const { reportWiseurl, clientcode, encrptionMessage } = response.data.responseData;
        
          let myForm = document.getElementById("form1");
        
          if (!myForm) {
            myForm = document.createElement("form");
            myForm.method = "post";
            myForm.action = reportWiseurl;
            myForm.id = "form1";
            myForm.target = "_blank";
            document.body.appendChild(myForm);
          } else {
            myForm.action = reportWiseurl; // Update action URL if form already exists
          }
        
          // Update or create hidden inputs
          const formData = [
            { name: "walletClientCode", value: clientcode },
            { name: "walletRequestMessage", value: encrptionMessage }
          ];
        
          formData.forEach(({ name, value }) => {
            let input = myForm.querySelector(`input[name="${name}"]`);
            if (!input) {
              input = document.createElement("input");
              input.type = "hidden";
              input.name = name;
              myForm.appendChild(input);
            }
            input.value = value; // Update value
          });
        
          myForm.submit();
          setOpen(""); // Assuming this is a state management function
        }
        else {     
          setRedeemClicked(false);
        //  CustomToast.error("Service is not working. Try after some time.");
        }
      } catch (error) {
        setRedeemClicked(false);
        //CustomToast.error("Service is not working. Try after some time.");
      }
    };

    fetchData();
  }
}, [userCode, linkId]);

const linkIdTitleMap = {
  100: "Auctioneer Detailed MIS",
  102: "Auctioneer Pay In Pay Out",
  101: "Auctioneer Statement",
  103: "Buyer Detailed MIS",
  104: "Buyer Statement",
  105: "Buyer Pay In MIS",
  106: "Seller Detailed MIS",
  107: "Seller Pay Out MIS",
  108: "Tea board Detailed MIS",
  109: "Warehouse Bank MIS",
  110: "Seller Statement",
  111: "Seller SPTF MIS",
  112: "Tea Board Ageing MIS",
  113: "Tea Board Payment Summary",
  114: "Tea Board Commission MIS",
  115: "Tea Board TCS MIS",
  116: "Payment Summary"
};
 const modalTitle = linkIdTitleMap[linkId] || "Report";
  return (
    <>
      <Modals
          title={modalTitle}
        show={open === "BankReportsUserRoleWise"}
        handleClose={() => setOpen("")}
        size="md"
      >
        {(userRole === "BUYER" || userRole === "TEABOARDUSER" || userRole === "AUCTIONEER" || userRole === "WAREHOUSE") && (
      <div style={{ border: "1px solid black", padding: "10px", margin: "2px" }}>
      {redeemClicked &&
          <div className="loading-spinner">Loading...</div> }
    </div>
        )}
      </Modals>
    </>
   
  );
}

export default BankReportsUserRoleWise;
